<template>
  <div class="testpaper">
    <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">{{title}}</div>
        <div class="back" @click="$router.go(-1)">返回</div>
      </div>
    </div>
    <div class="div"></div>
    <div class="main contain_main">
      <div class="issueitem" v-for="(issuelist,index) in list" :key="'issue'+index">
        <div class="title">
          {{issuelist.title}}
          <!-- <span>（共4题，20分）</span> -->
        </div>
        <issue
          v-for="(item,order) in issuelist.questions"
          :key="'order'+order"
          :total="issuelist.questions.length"
          :order="(order+1)"
          :message="item"
          :disabled='true'
          :showasw="false"
        ></issue>
      </div>
    </div>
    <div style="height:300px"></div>
  </div>
</template>

<script>
import issue from "../../components/issue";
import { ExamHistory_getInfo } from "../../assets/js/api.js";
export default {
  name: "recordexampaper",
  data() {
    return {
      list: [],
      ehuseranswer: [],
      title: null
    };
  },
  components: {
    issue
  },
  beforeMount() {
    if (this.$route.query.id) {
      this.getdata(this.$route.query.id);
    }
  },
  methods: {
    getdata(id) {
      ExamHistory_getInfo({ ehid: id }).then(res => {
        if (res.data.code == 200) {
          // 试卷题目数据矫正
          if (!res.data.data.ehquestion[0].title) {
            this.list = [
              { title: "试题", questions: res.data.data.ehquestion }
            ];
          } else {
            this.list = res.data.data.ehquestion;
          }
          this.title = res.data.data.ehsetting.examtitle;
          // 有答案得情况
          if (res.data.data.ehuseranswer) {
            // 试卷与试卷答案合并
            var map = new Map();
            res.data.data.ehuseranswer.forEach(item => {
              map.set(item.questionid - 0, item.questionanswer);
            });
            this.list = this.list.map(item => {
              item.questions = item.questions.map(quest => {
                quest.questionanswer = map.get(quest.questionid - 0);
                return quest;
              });
              return item;
            });
          }
        } else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    }
  }
};
</script>
<style lang="css" scoped>
.header {
  height: 0.75rem;
  width: 100%;
  border: 1px solid #e8e9ee;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header .title {
  min-width: 200px;
}
.div {
  display: block;
  content: "";
  height: 0.75rem;
  border: #474dff 1px solid;
}
.header_wrap {
  display: flex;
  justify-content: space-between;
  line-height: 0.75rem;
}
.record {
  position: absolute;
  bottom: 0rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  line-height: 0.2rem;
  width: 200%;
  color: #333;
  display: flex;
  justify-content: space-around;
}
em {
  color: red;
}
.header_wrap .title {
  font-size: 0.26rem;
  color: #474dff;
  position: relative;
}
.header_wrap .back {
  width: 1.1rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
  margin-top: 0.22rem;
}
.main .title {
  font-size: 0.24rem;
  text-align: left;
  margin-top: 0.6rem;
}
.title span {
  font-size: 0.12rem;
  color: "#777f90";
}
</style>


// WEBPACK FOOTER //
// src/pages/records/testpaper.vue